import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { SubscriptionService } from '../services/subscription.service';

@Injectable({
  providedIn: 'root'
})
export class SubsCancelGuard  {
  subscriptions: string[] = [];
  subscribedPlan: any;
  subscribedPlanId: any;
  constructor(private subscriptionService: SubscriptionService,private router: Router,){}
  async canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot):Promise<boolean>{ 
    await this.subscriptionService.userPlan().toPromise().then((data)=>{
      this.subscriptions = data.plans;
      this.subscribedPlanId = data.subscribed_plan_id;
      this.subscribedPlan = this.subscriptions.find((plan: any) => plan.subscription_id == this.subscribedPlanId);
      if(this.subscribedPlan && this.subscribedPlan.cancel_subscription == 1){
        return true;
      }else{
        this.router.navigateByUrl('/home');
        return false;
      }
  })
  return false;
   

  }
  
}
